import React from 'react';
import styles from '@dazn/lp-web/src/components/Countdown/countdown.module.css';
import {TCountdownTitlePriceBadge} from '@dazn/lp-web/src/types';

export const CountdownPriceBadge: React.FC<TCountdownTitlePriceBadge> = ({
    title,
    badgeText,
    discountAndPrice
}) => {
    return (
        <div
            className={styles.countdownPriceBadgeBox}
            id="countdown-price-badge"
        >
            {title && <div className={styles.countdownTitle}>{title}</div>}
            <div className={styles.countdownPriceBadgeContainer}>
                {badgeText && (
                    <div className={styles.countdownBadge}>
                        {badgeText.includes('{discountPercentage}') &&
                        discountAndPrice?.discountPercentage
                            ? badgeText.replace(
                                  '{discountPercentage}',
                                  discountAndPrice?.discountPercentage
                              )
                            : badgeText}
                    </div>
                )}
                {discountAndPrice && discountAndPrice.price && (
                    <div className={styles.price}>
                        {discountAndPrice?.price}
                    </div>
                )}
            </div>
        </div>
    );
};
